import { Box, type SxProps, type Theme } from "@mui/material";
import type { ReactNode } from "react";
import { SITE_MEDIA, SITE_VAR } from "src/domains/shared/constants/styles/site";

/** 구역 표시 — 이어지는 구역은 위 여백을 겹치지 않는다(사이트 전역 규칙 `[data-sec] + [data-sec]`) */
export const SITE_SECTION_ATTR = "data-sec";

export interface SiteSectionProps {
  children: ReactNode;
  id?: string;
  labelledBy?: string;
  label?: string;
  /**
   * 화면 밖에 있는 동안 그리기를 건너뛴다(`content-visibility: auto`). 값은 그리기 전 자리를 잡을 예상 높이(px) —
   * [넓은 화면, 900px 이하]. 한 번 그린 뒤에는 실제 높이를 기억한다.
   */
  skipOffscreen?: readonly [number, number];
  sx?: SxProps<Theme>;
}

/** 사이트 본문 구역(시안 `.sec`): 위아래 구역 여백. 첫 화면 아래 무거운 구역은 화면 밖에서 그리지 않는다. */
export function SiteSection({
  children,
  id,
  labelledBy,
  label,
  skipOffscreen,
  sx,
}: SiteSectionProps) {
  const offscreenSx = skipOffscreen
    ? {
        contentVisibility: "auto",
        containIntrinsicSize: `auto ${skipOffscreen[0]}px`,
        [SITE_MEDIA.tablet]: {
          containIntrinsicSize: `auto ${skipOffscreen[1]}px`,
        },
      }
    : {};
  return (
    <Box
      component="section"
      id={id}
      aria-labelledby={labelledBy}
      aria-label={label}
      {...{ [SITE_SECTION_ATTR]: "" }}
      sx={[
        { paddingBlock: SITE_VAR.section },
        offscreenSx,
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {children}
    </Box>
  );
}
